import styled from 'styled-components'

import Input from '../../molecules/Input'

export const StyledTimeInput = styled(Input)`
  width: ${({ width }) => width || '100%'};
`
